import MetamodelStore from "../resources/data/MetamodelStore";
import JsonTreeDataCreator from "./JsonTreeDataCreator";

export default class JsonTreeCommons
{
    static getDataForRelationModal = (aParams) =>
    {
        const aData = aParams.data;

        // console.log("keyPath", keyPath)
        // console.log("aData", aData);
        const aRelations = MetamodelStore.getInstance().getRelations();
        if (!aRelations)
        {
            console.error("No relations found!");
            return;
        }
        const aRelation = Object.values(aRelations).find(aRel =>
        {
            return aRel.sName === aData.sName;
        });
        if (!aRelation)
        {
            console.error("No relation with sName: '" + aData.sName + "' found!");
            return;
        }
        // console.log("aRelation", aRelation);
        const aNotebookStructure = aRelation.notebookStructure;

        // aData.direction = "INCOMING"

        let sEpId;
        if ("INCOMING" === aData.direction)
        {
            sEpId = aRelation.aFromEndpoint;
        }
        else if ("OUTGOING" === aData.direction)
        {
            sEpId = aRelation.aToEndpoint;
        }
        const aEps = MetamodelStore.getInstance().getEndpoints();
        if (!aEps || !aEps.hasOwnProperty(sEpId))
        {
            console.error("Cannot find endpoint for relation '" + aData.sName + "'!");
        }
        const aEndpoint = aEps[sEpId];
        // console.log("aEndpoint", aEndpoint);

        const aTargetsFiltered = MetamodelStore.getInstance().getEpVisibleTargets(aEndpoint.id)
        const aTargetsModeltypes = aTargetsFiltered.filter(aTrg =>
        {
            return aTrg.isModeltype ? true : false;
        });
        const aTargetsClasses = aTargetsFiltered.filter(aTrg =>
        {
            return aTrg.isClass ? true : false;
        });
        // console.log("aTargetsFiltered", aTargetsFiltered);
        // console.log("aNotebookStructure", aNotebookStructure);

        const aRelNotebook = aNotebookStructure ? JsonTreeDataCreator.notebookData(aNotebookStructure) :
        {};
        // console.log("aRelNotebook", aRelNotebook);
        let aTargetsNotebooks = {
            modeltypes:
            {},
            classes:
            {}
        };
        const aTargetClassesIds = aTargetsClasses.map(aTrg =>
        {
            return aTrg.id;
        });

        const aTargetModeltypesIds = aTargetsModeltypes.map(aTrg =>
        {
            return aTrg.id;
        });

        aTargetsNotebooks.classes = JsonTreeDataCreator.superNotebookData("objects", aTargetClassesIds, undefined, false);
        aTargetsNotebooks.modeltypes = JsonTreeDataCreator.superNotebookData("modeltypes", aTargetModeltypesIds);

        return {
            targetNotebooks: aTargetsNotebooks,
            modelID: aTargetModeltypesIds,
            relNotebook: aRelNotebook
        };
    }
}